import React, { Component } from "react";
import ContentWrapper from "./../../../template/Layout/ContentWrapper";
import { withRouter } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import { Services } from "../../../../repositories/clients/Services";
import MpaJson from "../../../../models/mapJson.js";
import Loader from "../../../Global/Loader";
import { withNamespaces } from "react-i18next";
import RepositoryFactory from "../../../../repositories/RepositoryFactory";
import { openNotification } from "../../Components/Notification/index.js";
import SumaryDetail from "./Sumary/SumaryDetail";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import largeIMG from "../../../../resources/logo-xpdconnect-blanco.png";
import LogoAzul from "../../../../resources/logo-xpdconnect-azul.svg";
import { Col } from "reactstrap";

const HashTable = require("../../Components/utils/HashTable");
const PurchaseOrderClient = RepositoryFactory.get("PurchaseOrder");
class ShipmentDetail extends Component {
  state = {
    token: this.props.match.params.token,
    id: null,
    userId: null,
    lng: null,
    fullLoader: false,
    markers: [],
    Resumen: [],
    polylineData: [],
    dataMap: [],
    rolId: this.props._rolId,
    tokenValid: true,
    tables: [],
    i18nLoadedAt: Date.now(),
  };

  getLocalizedTableDefinitions = () => ({
    baseTables: {
      routes: {
        key: "Rutas",
        title: this.props.t("transshipment"),
        columns: [
          {
            label: this.props.t("secuence"),
            key: "LegNumber",
            minWidth: 100,
            maxWidth: 100,
          },
          {
            label: this.props.t("location"),
            key: "Country",
            minWidth: 250,
            maxWidth: 250,
          },
          {
            label: this.props.t("trip_flight"),
            key: "Voyage_FlightNo",
            minWidth: 250,
            maxWidth: 250,
          },
          { label: this.props.t("vessel"), key: "Vessel" },
          { label: this.props.t("transport_mode"), key: "TransportMode" },
          { label: this.props.t("atd"), key: "ATD" },
          { label: this.props.t("ata"), key: "ATA" },
          { label: this.props.t("etd"), key: "ETD" },
          { label: this.props.t("eta"), key: "ETA" },
        ],
      },
      so: {
        key: "SO",
        title: this.props.t("order_ref"),
        columns: [
          {
            label: this.props.t("number"),
            key: "RefCustomer",
            minWidth: 250,
            maxWidth: 250,
          },
        ],
      },
      packages: {
        key: "Containers",
        title: this.props.t("packages"),
        columns: [
          {
            label: this.props.t("line"),
            key: "LineContainer",
          },
          {
            label: this.props.t("total_packages"),
            key: "Packages",
          },
          {
            label: this.props.t("total_píeces"),
            key: "Pieces",
          },
          {
            label: this.props.t("package_type"),
            key: "Measure",
          },
          {
            label: this.props.t("chargable_weight"),
            key: "UOMWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("gross_weight"),
            key: "UOMGrossWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("total_volume"),
            key: "UOMVolumeDescription",
            format: "dimension",
          },
          {
            label: this.props.t("dimensions"),
            key: "UOMDimensionsDescription",
            format: "dimension",
          },
          {
            label: this.props.t("goods_description"),
            key: "GoodsDescription",
            minWidth: 250,
            maxWidth: 250,
          },
        ],
      },
    },
    seaFCLOverrides: {
      containers: {
        key: "Containers",
        title: this.props.t("containers"),
        columns: [
          {
            label: this.props.t("contianer_num"),
            key: "ContainerNo",
            minWidth: 250,
            maxWidth: 250,
          },
          {
            label: this.props.t("status"),
            key: "Status",
            minWidth: 150,
            maxWidth: 150,
            custom: (value) =>
              value.Status ? (
                <span class="badge badge-euro">{value.Status}</span>
              ) : null,
          },
          { label: this.props.t("container_type"), key: "ContainerType" },
          { label: this.props.t("seal"), key: "Seal" },
        ],
      },
    },
    airHouseOverrides: {
      waybill: {
        key: "Waybill",
        title: this.props.t("house_air_way"),
        columnsTable: [
          {
            label: "",
            key: "",
            CollapseTable: true,
            flatColor: true,
            keydatavalidate: "Status",
            minWidth: 50,
            maxWidth: 50,
          },
          { label: "HAWB", key: "HouseReference" },
          { label: this.props.t("orders_reference"), key: "RefCustomer" },
          { label: this.props.t("pickup_address"), key: "PickupLocation" },
          { label: this.props.t("pickup_date"), key: "LinePickupDate" },
          { label: this.props.t("delivery_address"), key: "DeliveryLocation" },
          { label: this.props.t("delivery_date"), key: "LineDeliveryDate" },
        ],
        subTable: [
          {
            label: this.props.t("line"),
            key: "LineHouse",
            minWidth: 50,
            maxWidth: 50,
          },
          { label: this.props.t("packages"), key: "Packages" },
          { label: this.props.t("pieces"), key: "Pieces" },
          { label: this.props.t("package_type"), key: "Measure" },
          {
            label: this.props.t("weight"),
            key: "UOMWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("gross_weight"),
            key: "UOMGrossWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("volume"),
            key: "UOMVolumeDescription",
            format: "dimension",
          },
          {
            label: this.props.t("dimensions"),
            key: "UOMDimensionsDescription",
            format: "dimension",
          },
          {
            label: this.props.t("shipment_descriptions"),
            key: "GoodsDescription",
            minWidth: 250,
            maxWidth: 250,
          },
        ],
        subHeader: (
          <>
            <th>{this.props.t("line")}</th>
            <th>{this.props.t("packages")}</th>
            <th>{this.props.t("pieces")}</th>
            <th>{this.props.t("package_type")}</th>
            <th>{this.props.t("weight")}</th>
            <th>{this.props.t("gross_weight")}</th>
            <th>{this.props.t("volume")}</th>
            <th>{this.props.t("dimensions")}</th>
            <th>{this.props.t("shipment_descriptions")}</th>
          </>
        ),
      },
    },
  });

  componentDidMount() {
    const { token } = this.state;

    if (token) {
      this.fetchShipmentFromToken(token);
    }
  }

  fetchShipmentFromToken = async (token) => {
    try {
      const url = `${Services.TRACEABILITY.path}trazabilidad/decode-share`;
      const { data } = await axios.post(url, { token });

      if (data?.data) {
        const { shipmentId, userId, lng } = data.data;

        await this.props.i18n.changeLanguage(lng);

        this.setState(
          {
            id: shipmentId,
            userId,
            lng,
            i18nLoadedAt: Date.now(),
          },
          () => {
            this.getShipmentsForId(token);
          },
        );
      }
    } catch (error) {
      const browserLang = navigator.language || navigator.userLanguage;
      let lng = browserLang.split("-")[0];

      if (lng === "es") lng = "MX";
      else if (lng === "en") lng = "US";
      else lng = "MX";

      await this.props.i18n.changeLanguage(lng);

      this.setState({ tokenValid: false, fullLoader: true });
    }
  };

  validarRail = (resumeModel, info) => {
    const allowedServiceTypes = ["Import", "Export", "Crosstrade"];
    const allowedShipmentTypes = ["FTL", "LTL"];

    const shouldShowBorderFields =
      allowedServiceTypes.includes(info.ServiceType) &&
      allowedShipmentTypes.includes(info.ShipmentType);

    if (!shouldShowBorderFields) {
      const fieldsToRemove = [
        "ArrivalBorderDate",
        "ArrivalCustomsDate",
        "BorderDepartureDate",
      ];

      if (resumeModel[1] && Array.isArray(resumeModel[1].data)) {
        resumeModel[1].data = resumeModel[1].data.filter(
          (item) => !fieldsToRemove.includes(item.key),
        );
      }
    }

    const allowedShipmentTypesForContainers = ["FCL", "LCL"];
    const shouldShowContainerFields =
      allowedShipmentTypesForContainers.includes(info.ShipmentType);

    if (!shouldShowContainerFields) {
      const containerFieldsToRemove = [
        "MBL_AWB_PRO",
        "Vessel",
        "TotalContainers",
        "TotalTEUS",
      ];

      if (resumeModel[2] && Array.isArray(resumeModel[2].data)) {
        resumeModel[2].data = resumeModel[2].data.filter(
          (item) => !containerFieldsToRemove.includes(item.key),
        );
      }

      if (resumeModel[3] && Array.isArray(resumeModel[3].data)) {
        resumeModel[3].data = resumeModel[3].data.filter(
          (item) => !containerFieldsToRemove.includes(item.key),
        );
      }
    }

    return resumeModel;
  };

  getTablesByTransport = ({ mode, shipmentType, isHouseAir }) => {
    const { baseTables, seaFCLOverrides, airHouseOverrides } =
      this.getLocalizedTableDefinitions();

    let tables = [_.cloneDeep(baseTables.routes), _.cloneDeep(baseTables.so)];

    if (mode === "Sea" && shipmentType === "FCL") {
      tables.push(_.cloneDeep(seaFCLOverrides.containers));
    } else if (isHouseAir) {
      tables.push(_.cloneDeep(airHouseOverrides.waybill));
    } else if (mode === "Rail") {
      if (shipmentType === "FCL") {
        tables.push(_.cloneDeep(seaFCLOverrides.containers));
      } else if (["LCL", "FTL", "LTL"].includes(shipmentType)) {
        tables.push(_.cloneDeep(baseTables.packages));
      }
    } else {
      tables.push(_.cloneDeep(baseTables.packages));
    }

    return tables;
  };

  getShipmentsForId = async (token) => {
    try {
      const { userId, lng, id } = this.state;

      const urlDataShipment = `${Services.TRACEABILITY.path}trazabilidad/data-shipment-share/${id}?user=${userId}&lang=${lng}`;
      const requestGetPO = {
        userId: userId,
        limit: 10,
        pag: 1,
        shipmentId: id,
        lang: lng,
      };

      const [shipmentRes, POs] = await Promise.all([
        axios.get(urlDataShipment, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        PurchaseOrderClient.getOrdersShipmentShare(requestGetPO, token),
      ]);

      const data = shipmentRes.data.data;

      const { markers, polylineData } = this.buildMarkers(data);

      const transportTemplates = {
        1: MpaJson.cardResumenMaritimoPublic,
        2: MpaJson.cardResumenAereoPublic,
        3: MpaJson.cardResumenTerrestrePublic,
        4: MpaJson.cardResumenRailPublic,
      };

      const resumeModel = _.cloneDeep(
        transportTemplates[data.infoEmbarque.TransportModeCode] ||
          MpaJson.cardResumenTerrestre,
      );

      if (data.infoEmbarque.TransportModeCode === 4) {
        this.validarRail(resumeModel, data.infoEmbarque);
      }

      const newResume = resumeModel.map((f) => {
        f.data.forEach((g) => {
          if (g.infoTool) {
            g.arrayInfoTool.forEach((aif) => {
              aif.value = data.infoEmbarque[aif.key];
            });
          }
          g.value = data.infoEmbarque[g.key];
          g.value2 = data.infoEmbarque[g.key2];
          if (f.infoTool) {
            f.arrayInfoTool.forEach((aif) => {
              aif.value = data.infoEmbarque[aif.key];
            });
          }
        });
        return f;
      });

      const isHouseAir =
        data.infoEmbarque.TransportMode === "Air" &&
        data.infoEmbarque.ServiceType === "Export";

      if (isHouseAir) {
        const containers = data.Containers || [];
        const Table = new HashTable();

        containers.forEach((dataWaybill) => {
          if (Table.exist(dataWaybill.HouseReference)) {
            const Factura = Table.getElement(dataWaybill.HouseReference);
            Factura.sub.push({
              Packages: dataWaybill.Packages,
              Pieces: dataWaybill.Pieces,
              Measure: dataWaybill.Measure,
              UOMWeightDescription: dataWaybill.UOMWeightDescription,
              UOMGrossWeightDescription: dataWaybill.UOMGrossWeightDescription,
              UOMVolumeDescription: dataWaybill.UOMVolumeDescription,
              UOMDimensionsDescription: dataWaybill.UOMDimensionsDescription,
              LineHouse: dataWaybill.LineHouse,
              GoodsDescription: dataWaybill.GoodsDescription,
            });
            Table.updateElement(dataWaybill.HouseReference, Factura);
          } else {
            Table.addElement(dataWaybill.HouseReference, {
              ...dataWaybill,
              sub: [
                {
                  Packages: dataWaybill.Packages,
                  Pieces: dataWaybill.Pieces,
                  Measure: dataWaybill.Measure,
                  UOMWeightDescription: dataWaybill.UOMWeightDescription,
                  UOMGrossWeightDescription:
                    dataWaybill.UOMGrossWeightDescription,
                  UOMVolumeDescription: dataWaybill.UOMVolumeDescription,
                  UOMDimensionsDescription:
                    dataWaybill.UOMDimensionsDescription,
                  LineHouse: dataWaybill.LineHouse,
                  GoodsDescription: dataWaybill.GoodsDescription,
                },
              ],
            });
          }
        });

        data.Waybill = Table.elements();
      }

      /**
       * Revision de tablas a mostrar, dependiendo el tipo de transporte y embarque
       * 1 Sea
       * 2 Air
       * 3 Road
       */

      const netTabla = this.getTablesByTransport({
        mode: data.infoEmbarque.TransportMode,
        shipmentType: data.infoEmbarque.ShipmentType,
        isHouseAir,
      });
      netTabla.forEach((f) => {
        let defaultData = [{}];
        if (f.key === "EmissionsC02") {
          let co2 = "";
          let distance = "";
          let average = "";
          if (data.infoEmbarque && data.infoEmbarque.CO2) {
            co2 = data.infoEmbarque.CO2;
          }
          if (data.infoEmbarque && data.infoEmbarque.Distance) {
            distance = data.infoEmbarque.Distance;
          }
          if (data.infoEmbarque && data.infoEmbarque.Average) {
            average = data.infoEmbarque.Average;
          }
          defaultData = [
            {
              CO2: co2,
              Distance: distance,
              Average: average,
            },
          ];
        } else if (data[f.key] && data[f.key].length > 0) {
          defaultData = data[f.key];
        }
        f.data = defaultData;
      });
      const findSOTable = netTabla.find((f) => f.key === "SO");
      if (!findSOTable.data || !findSOTable.data.length) {
        netTabla.splice(netTabla.indexOf(findSOTable), 1);
      } else if (
        findSOTable.data.length === 1 &&
        Object.keys(findSOTable.data[0]).length === 0
      ) {
        netTabla.splice(netTabla.indexOf(findSOTable), 1);
      }

      if (POs?.data.length) {
        let POTable = {
          columns: [
            {
              label: this.props.t("po_no"),
              key: "PONumber",
              minWidth: 150,
              maxWidth: 200,
            },
          ],
          data: POs.data,
          title: this.props.t("purchase_order"),
          key: "PO",
        };
        POTable.columnsTable = POTable.columns;
        netTabla.splice(1, 0, POTable);
      }
      this.setState(
        {
          markers,
          dataMap: polylineData,
          polylineData,
          Resumen: newResume,
          tables: netTabla,
          shipment: data.infoEmbarque,
          DoEmbarque: data.infoEmbarque ? data.infoEmbarque.DoEmbarque : "",
          ModoTransporte: data.infoEmbarque
            ? data.infoEmbarque.ModoTransporte
            : "",
          cliente: data.infoEmbarque ? data.infoEmbarque.Cliente : "",
        },
        () => {
          this.getEvents(token);
        },
      );
    } catch (error) {
      console.log("🚀 ~ ShipmentDetail ~ error:", error);
      openNotification("error", this.props.t("Data_entered_is_invalid"));
    }
  };

  buildMarkers(data) {
    const markers = [];
    const polylineData = [];

    const addMarker = (key, title, lat, lng) => {
      if (lat && lng) {
        markers.push({
          key,
          title,
          data: data.infoEmbarque,
          position: { lat: Number(lat), lng: Number(lng) },
          icon: {
            url:
              data.infoEmbarque.TCC === "1"
                ? "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapaTCC.png"
                : "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapa.png",
          },
        });
        polylineData.push({ lat: Number(lat), lng: Number(lng) });
      }
    };

    addMarker(
      1,
      this.props.t("origin"),
      data.infoEmbarque.POLLatitude,
      data.infoEmbarque.POLLongitude,
    );
    addMarker(
      2,
      this.props.t("destination"),
      data.infoEmbarque.PODLatitude,
      data.infoEmbarque.PODLongitude,
    );

    return { markers, polylineData };
  }

  getEvents = async (token) => {
    const { id, lng } = this.state;

    try {
      const response = await axios.get(
        `${Services.TRACEABILITY.path}trazabilidad/shipment-events-share/${id}?lang=${lng}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      this.setState({
        steps: response.data.steps,
        fullLoader: true,
      });
    } catch (error) {
      console.log("🚀 ~ error:", error);
    }
  };

  exportPDF = () => {
    this.setState({ fullLoader: false });

    const icon = document.getElementById("icon-pdf");
    if (icon) icon.classList.add("hide-on-pdf");
    const input = document.getElementById("embarque-content");
    input.classList.add("export-mode");
    input.classList.add("export-header");

    html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
      input.classList.remove("export-mode");
      input.classList.remove("export-header");

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("embarque.pdf");

      this.setState({ fullLoader: true }, () => {
        if (icon) icon.classList.remove("hide-on-pdf");
        openNotification(
          "success",
          this.props.t("shipmen_detail_share_shipment_download_pdf_success"),
        );
      });
    });
  };

  render() {
    let {
      markers,
      polylineData,
      Resumen,
      tables,
      shipment,
      fullLoader,
      rolId,
      userId,
      token,
      i18nLoadedAt,
      tokenValid,
    } = this.state;

    return (
      <>
        <Loader hidden={fullLoader} />
        {tokenValid ? (
          <div id="embarque-content" key={i18nLoadedAt}>
            <div className="wrapper">
              <header className="topnavbar-wrapper">
                <nav className="navbar topnavbar">
                  <div className="navbar-header">
                    <a className="navbar-brand">
                      <div className="brand-logo">
                        <img
                          className="large-logo-header"
                          src={largeIMG}
                          alt="App Logo"
                        />
                      </div>
                    </a>
                  </div>
                </nav>
              </header>

              <ContentWrapper>
                <div>
                  <div className="content-heading-share">
                    <span className="icon-shipments-visibility icon-header" />
                    {this.props.t("shipmentsVisibility")}
                    <img
                      style={{ marginRight: "35px" }}
                      className="euro-return-tittle"
                      id="icon-pdf"
                      title={this.props.t(
                        "shipmen_detail_share_shipment_download_pdf_tooltip",
                      )}
                      src={
                        "https://magiclog.blob.core.windows.net/europartnerspic/pdficon.png"
                      }
                      width="30px"
                      onClick={() => this.exportPDF()}
                    />
                  </div>
                  <SumaryDetail
                    markers={markers}
                    dataMap={polylineData}
                    polylineData={polylineData}
                    Resumen={Resumen}
                    tables={tables}
                    shipment={shipment}
                    steps={this.state.steps}
                    rolId={rolId}
                    userId={userId}
                    token={token}
                  />
                </div>
              </ContentWrapper>
            </div>
          </div>
        ) : (
          <div>
            <Col
              xs={12}
              md={10}
              lg={6}
              className="ml-auto mr-auto mt-auto mb-5"
            >
              <center className="pt-5">
                <img src={LogoAzul} alt="now-logo" className="logo-login" />
                <Col xs={12} md={12} lg={12} className="ml-auto mr-auto">
                  <span style={{ fontSize: "40px" }}>
                    {this.props.t("shipmen_detail_share_invalid_or_expired")}
                  </span>
                </Col>
              </center>
            </Col>
          </div>
        )}
      </>
    );
  }
}
export default withNamespaces()(withRouter(ShipmentDetail));
